<template>
    <div
        :class="['row user-table-row align-items-center', shopView ? 'black-bg' : '']">
        <template v-if="user && user.person && user.role">
            <div class="col-12 col-md-2 open-td" @click="$emit('open')">
                <icon
                    :name="open ? 'icon-cph_iconset_grip' : 'icon-cph_iconset_plus'"
                    fontSize="2em"
                    color="#000"
                    :style="{opacity: showIcon ? '1' : '0'}"/>
            </div>
            <div class="col-12 col-md-3 col-lg-2">{{user.role.displayName}}
            </div>
            <div class="col-12 col-md-3 col-lg-2">{{user.address ?
                user.address.companyName : ''}}
            </div>
            <div class="col-12 col-md-4 col-lg-3">{{user.person.firstName}}
                {{user.person.lastName}}
            </div>
            <div class="col-12 d-flex justify-content-center col-lg-3"
                 v-if="showButtons">
                <button class="btn icon-btn pr-0 mx-1"
                        name="Shops"
                        data-toggle="tooltip"
                        :disabled="$isNotAllowed($TYPES.ACTIONS.UPDATE, user.role.name)"
                        data-placement="top"
                        :title="$t('UI.showShops')"
                        @click.stop="$emit('showShops')"
                        v-if="$isAllowed($TYPES.ACTIONS.UPDATE, user.role.name)">
                    <i class="icon icon-cph_iconset_minilab shop-icon">
                        <span class="badge badge-light shop-badge"
                              v-if="user.shops && user.shops.length > 0">
                            {{user.shops.length}}
                        </span>
                    </i>
                </button>
                <button class="btn icon-btn pr-0 mx-1"
                        name="Add child user"
                        data-toggle="tooltip"
                        data-placement="top"
                        :disabled="$isNotAllowed($TYPES.ACTIONS.UPDATE, user.role.name)"
                        :title="$t('UI.addChild')"
                        @click.stop="addChildUser(user)"
                        v-if="$isAllowed($TYPES.ACTIONS.UPDATE, user.role.name)
                            && $isAllowed($TYPES.ACTIONS.ADD, user.role.name)
                            && $isAllowed('canThisRoleAddChildren', (user.role.name))">
                    <i class="icon icon-cph_iconset_plus"></i>
                </button>
                <button class="btn icon-btn pr-0 mx-1"
                        name="edit user"
                        data-toggle="tooltip"
                        data-placement="top"
                        :disabled="$isNotAllowed($TYPES.ACTIONS.UPDATE, user.role.name)"
                        :title="$t('UI.edit')"
                        @click.stop="editUser(user)"
                        v-if="$isAllowed($TYPES.ACTIONS.UPDATE, user.role.name)">
                    <i class="icon icon-cph_iconset_edit"></i>
                </button>
                <button class="btn icon-btn pr-0 mx-1"
                        @click.stop="handleUserDeletion({
                            question: $t('COMPANYDATA.remove'),
                            data: user, callback: DelUser
                        })"
                        name="remove user"
                        data-toggle="tooltip"
                        data-placement="top"
                        :title="$t('COMPANYDATA.remove')"
                        v-if="$isAllowed($TYPES.ACTIONS.REMOVE)
                            && $isAllowed($TYPES.ACTIONS.ADD, user.role.name)
                            && !user.dependents">
                    <i class="icon icon-cph_iconset_trash_can"></i>
                </button>
            </div>
        </template>
    </div>

</template>
<script type="text/babel">
import {mapActions, mapGetters} from 'vuex';
import {RegistrationPerimeter} from '../../../../router/perimeters/registrationPerimeter';
import Icon from '../../../Shared/Icons/Icon';
import {EventBus} from '@/eventbus';

export default {
    name: 'user-table-item',
    perimeters: [RegistrationPerimeter],
    components: {Icon},
    props: {
        user: {
            type: [Object, Array]
        },
        open: {
            type: Boolean
        },
        showIcon: {
            type: Boolean
        },
        showButtons: {
            type: Boolean,
            default: true
        },
        shopView: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters({userId: 'getUserId', loggedUser: 'getUser'})
    },
    methods: {
        ...mapActions([
            'confirmAction',
            'DelUser'
        ]),
        editUser (user) {
            this.$emit('changeTab', {
                name: 'Register',
                data: user,
                parentId: user.parentId,
                parentRole: user.role.name
            });
        },
        addChildUser (user) {
            this.$emit('changeTab', {
                name: 'Register',
                data: null,
                parentId: user.id,
                parentRole: user.role.name
            });
        },
        async handleUserDeletion (opts) {
            await this.confirmAction(opts);
            EventBus.$emit('updateUserList');
        }
    }
};
</script>

<style lang="scss">
    .icon, .shop-icon {
        position: relative;
        .badge.shop-badge {
            position: absolute;
            top: -8px;
            right: -1px;
        }
    }
</style>
